export const TranStyle = theme => ({
  /**
   * modified ag grid default theme
   */

  agThemeModified: {
    height: '100%'
  },

  /**
   * ag grid tran container
   */

  tranContainer: {
    height: '80vh',
    marginTop: '3vh',
    marginLeft: '2vw',
    width: '94%'
  },

  /**
   * if browser width is less or equal to 1800px
   */

  '@media screen and (max-width: 1800px)': {
    tranContainer: {
      height: '72vh'
    }
  },

  /**
   *  release dropdown select container
   */

  tranReleaseContainer: {
    padding: '10px',
    minWidth: '270px',
    maxWidth: '270px'
  },

  ofxFileSelectionContainer: {
    padding: '2px',
  },
  /**
   *  release select field
   */
  tranReleaseSelect: {
    display: 'flex'
  },

  tranReleaseSelectWidth: {
    width: 'auto', 
    minWidth: '300px'
  },

	newReleaseButton            : {
		margin : theme.spacing(2)
	},

	button            : {
		margin : theme.spacing(2)
	},
	newReleaseModal             : {
		paddingTop    : '10px',
		paddingBottom : '10px',
		maxWidth      : '470px',
		minHeight     : '270px',
		maxHeight     : '270px',
		paddingRight  : '1.2rem',
		paddingLeft   : '1.2rem'
  },
  
	newReleaseModalActions      : {
		display        : 'flex',
    justifyContent : 'start',
		marginTop      : '20px',
		marginBottom   : '10px',
		paddingRight   : '1.2rem',
		paddingLeft    : '1.2rem'
  },
  
  ofxUploadActions      : {
		display        : 'flex',
    justifyContent : 'space-evenly',
		marginTop      : '0px',
		paddingRight   : '1.2rem',
		paddingLeft    : '1.2rem'
  },
  
	textField                   : {
		paddingTop : '5px',
		textAlign  : 'left',
		width      : '100%'
	},
	sqlErrorMessage             : {
		marginTo : '5px',
		color    : 'red'
  }
});

